import { create } from 'zustand'

import type { DutyToolKey } from '@/features/duties/types'

interface CardVisibilityState {
  /** dutyId → per-card visibility overrides on top of the server default */
  overrides: Record<string, Partial<Record<DutyToolKey, boolean>>>
  getOverrides: (
    dutyId: string
  ) => Partial<Record<DutyToolKey, boolean>> | undefined
  setCardVisible: (dutyId: string, key: DutyToolKey, visible: boolean) => void
}

/**
 * Show/hide state for pills whose toggle is never persisted: the post-call
 * configuration cards (Fact Extraction, Labels & Mapping, Resequence) and
 * Fast First Message, whose server default
 * derives from whether a first message is set. Module-level so it survives tab
 * switches; intentionally not persisted anywhere.
 */
export const useCardVisibilityStore = create<CardVisibilityState>()(
  (set, get) => ({
    overrides: {},
    getOverrides: (dutyId) => get().overrides[dutyId],
    setCardVisible: (dutyId, key, visible) =>
      set((state) => ({
        overrides: {
          ...state.overrides,
          [dutyId]: { ...state.overrides[dutyId], [key]: visible },
        },
      })),
  })
)
